import TableFiltersRow from './TableFiltersRow'

export default TableFiltersRow
